import type { QuestionnaireAnswers } from '@shared';

const QUESTIONS_WITH_EDITABLE_OTHER = new Set<string>([
  'primary_goal',
  'secondary_goals',
  'tech_stack',
  'ltc_challenges',
]);

const OTHER_TEXT_FIELD_BY_QUESTION: Record<string, keyof QuestionnaireAnswers> = {
  primary_goal: 'primary_goal_other_text',
  secondary_goals: 'secondary_goals_other_text',
  tech_stack: 'tech_stack_other_text',
  ltc_challenges: 'ltc_challenges_other_text',
};

export function supportsEditableOther(questionId: string): boolean {
  return QUESTIONS_WITH_EDITABLE_OTHER.has(questionId);
}

export function getOtherTextField(questionId: string): keyof QuestionnaireAnswers | null {
  return OTHER_TEXT_FIELD_BY_QUESTION[questionId] ?? null;
}
